import Head from 'next/head';
import React from 'react';
import { withLayout } from '../Layout/Layout';
import {Support} from "../components/Support/Support";

export const SupportHOC = ({ setLoginDialogState }) => {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/booking-support`} />
        <meta
          name="description"
          content={
            'Learn more about First-Class.com, your trusted source for luxury travel and lifestyle content. Discover our mission, team, and dedication to providing premium insights'
          }
        />
        <title>Support First-Class: Your Premium Travel Resource</title>
      </Head>
      <Support setLoginDialogState={setLoginDialogState} />
    </>
  );
};
export default withLayout(SupportHOC, true);
